<template>
  <div class="wrapper wrapper-light">
    <div class="v-loader" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.v-loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid $primary;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
